import angular from 'angular';
import template from './toggle-password-visibility.html';
class TogglePasswordVisibilityController {
    constructor() {
        this.isShownPassword = false;
    }
    $onInit() {
        this.togglePasswordVisibility = () => {
            this.isShownPassword = !this.isShownPassword;
            if (this.onToggle) {
                this.onToggle({ fieldType: _getPasswordInputType() });
            }
        };
        this.getPasswordIcon = () => {
            return this.isShownPassword ? 'eye' : 'eye-crossed';
        };
        const _getPasswordInputType = () => {
            return this.isShownPassword ? 'text' : 'password';
        };
    }
}
const togglePasswordVisibility = {
    template,
    bindings: {
        isSmall: '<',
        onToggle: '&',
    },
    controller: TogglePasswordVisibilityController,
};
export default angular
    .module('doxy.common.components.togglePasswordVisibility', [])
    // toggle-password-visibility
    .component('togglePasswordVisibility', togglePasswordVisibility).name;
